import { ref } from 'vue';
import { useNuxtApp, useRuntimeConfig, useCookie } from '#imports';
import axios from 'axios';

export function useFeedback() {
  const { $store } = useNuxtApp();
  const writableApi = useRuntimeConfig().public.WRITABLE_BASE_API_URL;
  const store = $store;

  const isLoading = ref(false);

  const submitFeedback = async (feedbackData = {}, sentiment = '', additionalDetails = '') => {
    if (!feedbackData || !sentiment) {
      console.error('Feedback data or sentiment not found');
      return;
    }
    if (!feedbackData.id || !feedbackData.type) {
      console.error('Subject ID and type are required');
      return;
    }
    store.commit('setFeedbackData', feedbackData);
    store.commit('setFeedbackSentiment', sentiment);

    try {
      isLoading.value = true;

      const secondary_organization_id = store.getters.getSecondaryOrgId;
      if (!secondary_organization_id) {
        console.error('Secondary organization ID not found');
        return;
      }

      const query_id = store.getters.getSearchUUID;
      if (!query_id) {
        console.error('Query ID not found');
        return;
      }

      const session_id = store.getters.getSessionId;
      if (!session_id) {
        console.error('Session ID not found');
        return;
      }

      const payload = {
        feedback: {
          subject_id: feedbackData.id,
          subject_type: feedbackData.type,
          sentiment: sentiment,
          category: feedbackData.category,
          query_id: query_id,
          session_id: session_id,
          search_result_position: feedbackData.result_position,
          subject_display_text: feedbackData.display_text,
          additional_details: additionalDetails.length > 0 ? additionalDetails : '',
        },
      };
      const { value: token } = useCookie('auth-token');
      const headers = token ? { Authorization: `${token}` } : {};

      await axios.post(`${writableApi}api/v4/o/${secondary_organization_id}/cms/public/user_feedback`, payload, {
        headers,
      });
    } catch (err) {
      console.error('Error submitting feedback:', err);
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    submitFeedback,
  };
}
